module.exports = __webpack_public_path__ + "static/media/truck-slider-3.139c20d3.jpg";